import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
// import jwt from 'jsonwebtoken';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { first } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-department-dashboard',
  templateUrl: './department-dashboard.component.html',
  styleUrls: ['./department-dashboard.component.scss']
})
export class DepartmentDashboardComponent implements OnInit {
  iframeUrl: any;
  userID: any;
  constructor(
    public cryptoService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private sanitizer: DomSanitizer, 
    public http: HttpClient, 
    private router: Router, 
    private deptDashBoardService : DepartmentDashboardService, 
    private messageService: MessageService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    //     // you will need to install via 'npm install jsonwebtoken' or in your package.json
    //     const metabaseUrl = 'environment.METABASE_SITE_URL';


    //     var payload = {
    //       resource: { dashboard: 9 },
    //       params: {
    //         'district':'bhiwani'
    //       },
    //       exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration
    //     };
    //     const data = {
    //       payload: payload,
    //       token: METABASE_SECRET_KEY
    //     }
    //     // public post(url: string, data: any, options?: any) { 
    //    const res = this.http.post('http://localhost:3000/api/v1/jsonwebtoken', data);
    //    res.subscribe((data: any) =>{
    //     var token = data.token
    //      let Url = metabaseUrl + "/embed/dashboard/" + token + "#bordered=true&titled=true";
    //     this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Url)
    // });
    let dashboardType = this.router.url.split('/')?.[3];
    let reqBody = {
      dashboardType : null
    }
    if(dashboardType === 'micada_geography'){
      this.activityRecordService.activityRecord(this.userID, 'MICADA Geography', '', new Date(), 'Success');

      reqBody.dashboardType = 'Micada_Geographic'  
    }else if(dashboardType === 'vendor_metrics'){
      this.activityRecordService.activityRecord(this.userID, 'Venodr Metrics', '', new Date(), 'Success');

      reqBody.dashboardType = 'Vendor_Metrics'
    }else if(dashboardType === 'app_verification'){
      this.activityRecordService.activityRecord(this.userID, 'Application Verification Single View', '', new Date(), 'Success');

      reqBody.dashboardType = 'Application_Verification_Single_View'
    }
    this.getIframeUrl(reqBody);

  }

  getIframeUrl(reqBody){
    this.loader.start();
    this.deptDashBoardService.getDashboardIframeUrl(reqBody)
        .pipe(first())
        .subscribe({
          next: (data : any) => {
            this.loader.close();
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data?.URL)
          },
          error: () => {
            this.loader.close();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Applications not loaded.' });

          }
        });
  }
}
